import { Component, ElementRef, ViewChild } from '@angular/core';
import {
  Conditions,
  Departments,
  deptpriceconfig,
  grades,
  pricetypeconfig,
  StoreGroupModel,
  storegrp,
  subCategories,
} from '../../../../Models/ApplicationModels';
import { MasterDataSeriveService } from '../../../../Services/master-data-serive.service';
import { CustomToastsService } from '../../../../Services/custom-toasts.service';
import { ExportExcelService } from '../../../../Services/export-excel.service';
import { AdminBreadcrumbsService } from '../../admin-services/admin-breadcrumbs.service';
import { PricingType, Status } from 'src/app/enum/enum';

@Component({
  selector: 'app-add-new-pricing',
  templateUrl: './add-new-pricing.component.html',
  styleUrls: ['./add-new-pricing.component.css'],
})
export class AddNewPricingComponent {
  @ViewChild('checkBtn') checkBtn?: ElementRef<HTMLElement>;
  @ViewChild('setPriceConfigModal') setPriceConfigModal!: ElementRef;
  modalInstance: any;
  receivedData: any;
  storegrp: StoreGroupModel = new StoreGroupModel();
  storeGroups: Array<StoreGroupModel> = [];
  departmentslist: Array<Departments> = [];
  selectedStoregrp: number = 0;
  sendStoreGrpConfig: Array<StoreGroupModel> = [];
  getCondition: Array<Conditions> = [];
  getQuality: Array<grades> = [];
  conditionQualities: Array<deptpriceconfig> = [];
  pricingType: Array<pricetypeconfig> = [];
  pricingData: any;
  price: deptpriceconfig = new deptpriceconfig();
  departmentsDetails: Departments = new Departments();
  categoryList: Array<any> = [];
  subCategoryList: Array<any> = [];
  subCategoryList1: Array<any> = [];
  pricingDataList: Array<any> = [];
  pricingTypeName!: string;
  pricingTypeID!: number;
  departmentName!: string;
  storeGroupName!: string;
  priceConfigPostDataString: string[] = [];
  selectedCategoryID: any = 0;
  selectedSubCategoryID: any = 0;
  prcingTypeConfigData: any;
  updateceategoryPriceData: any;
  Deptpriceconfigarray: Array<deptpriceconfig> = [];
  data: Departments = new Departments();
  status: string = 'Incomplete';
  selectedDept: any;
  isPricePresent: boolean = false;
  buttonDisabled: boolean = false;
  isModalHidden: boolean = false;
  red: string = 'red';
  showCustomSelect: boolean = true;
  showCustomSelect1: boolean = true;
  selectedVal: string = 'Choose Category';
  selectedVal1: string = 'Choose Sub-Category';
  deletePrices: string[] = [];
  departmentPrices: Array<deptpriceconfig> = [];
  checkDel: boolean = true;
  disablePost: boolean = false;
  obj = {
    Descr: 'Price 0',
    Price: 0,
    companyID: 0,
    pricingTypeID: 0,
  };
  selectedDeptForFiletr: any[] = [];
  tempData: any;
  tempDescr: string = '';
  dept: Departments = new Departments();
  selectedIds: string = '';
  existingPrices: any[] = [];
  constructor(
    private masterService: MasterDataSeriveService,
    private toaster: CustomToastsService,
    private adminBreadcrumbs: AdminBreadcrumbsService,
    private excelExport: ExportExcelService
  ) { }

  async ngOnInit() {
    try {
      this.adminBreadcrumbs.updateBreadcrumbs([
        { crumbName: 'Company Config', link: 'demo' },
        { crumbName: 'Pricing', link: 'pricing/pricing-config' },
        { crumbName: 'Add New Pricing', link: 'pricing/add-pricing' },
      ]);

      this.getAllDepartments();
      await this.getAllStoreGroup();
      this.getPricingType();
      await this.getAllPricingConfigs();
      await this.getDataForPriceConfig();
    } catch (error) {
      console.error('Error during component initialization:', error);
    }
  }

  toggleStoreGroups(index: number) {
    this.selectedStoregrp = index;
  }

  async getAllPricingConfigs() {
    let userdata = this.masterService.getUserDetailsFromStorage();
    let c_id = userdata.companyID;
    await this.masterService.getPricingTypeConfig(c_id).subscribe((res) => {
      if (res) {
        this.Deptpriceconfigarray = res as deptpriceconfig[];

        this.Deptpriceconfigarray.map((res) => {
          res.expirationDt = this.masterService.removeTimeFromDate(
            res.expirationDt
          );
          res.effectiveDt = this.masterService.removeTimeFromDate(
            res.effectiveDt
          );
        });
        this.selectedCategoryID > 0
          ? (this.subCategoryList1 = this.subCategoryList.filter(
            (item) => item.categoryId == this.selectedCategoryID
          ))
          : (this.subCategoryList1 = []);
      }
    });
  }

  filterExtendedPriceDepartments() {
    this.pricingDataList.forEach((listItem) => {
      if (listItem.priceId == undefined || listItem.priceId == 0) {
        this.departmentPrices.push(listItem);
      } else {
        let foundPricingItem = this.departmentPrices.find(
          (item) => item.priceId == listItem.priceId
        );
        let price = foundPricingItem?.price ?? 0;
        this.departmentPrices.forEach((pricingItem) => {
          if (pricingItem.price == price) {
            pricingItem.price = listItem.price;
          }
        });
      }
    });
    return this.departmentPrices;
  }

  async postPricingData(values: any) {

    if (this.selectedIds != '') {
      this.masterService
        .deletePricingConfig(this.selectedIds)
        .subscribe((res) => {
          if (res) {
            this.selectedIds = '';
            this.deletePrices = [];
          }
        });
    }

    this.disablePost = true;
    let postData = this.pricingDataList;

    try {
      if (
        this.pricingTypeID == 3 ||
        this.pricingTypeID == 5 ||
        this.pricingTypeID == 6
      ) {
        postData = this.filterExtendedPriceDepartments();
      }
      const dataToSend = postData
        .filter((price) => price.value !== undefined && price.value !== null)
        .map((price) => ({
          qualityDescr: price.descr,
          value: price.price,
        }));

      let userdata = this.masterService.getUserDetailsFromStorage();
      let companyID = userdata.companyID;

      for (const element of postData) {
        if (element.price > 0) {
          let qualityId =
            element.qualityId !== undefined
              ? element.qualityId
              : element.qualityId !== undefined
                ? element.qualityId
                : 0;

          let conditionId =
            element.conditionId !== undefined
              ? element.conditionId
              : element.conditionId !== undefined
                ? element.conditionId
                : 0;

          let priceId = element.priceId == undefined ? 0 : element.priceId;
          this.priceConfigPostDataString.push(
            `${this.pricingTypeID}|${this.prcingTypeConfigData.storeGroupId}|${qualityId}|${conditionId}|${element.price}|${this.prcingTypeConfigData.departmentId}|${this.selectedSubCategoryID}|${this.selectedCategoryID}|${companyID}|${userdata.userId}|${priceId}`
          );
        }
      }

      if (
        this.pricingTypeID != PricingType.PriceListDepartment &&
        this.pricingTypeID != PricingType.GbbDepartment &&
        this.pricingTypeID != PricingType.QualityConditionDepartment &&
        (this.priceConfigPostDataString.length == 0 ||
          this.selectedCategoryID == 0)
      ) {
        this.toaster.error(
          'Please select category or subcategory and add atleast one price greater than 0'
        );
        this.disablePost = false;
        return;
      }

      await this.masterService
        .addupdatelistofprices(this.priceConfigPostDataString)
        .toPromise();

      this.priceConfigPostDataString = [];
      await this.getAllPricingConfig(this.data);
      this.toaster.success('The Price is Added');
      (await this.selectedCategoryID) > 0
        ? (this.subCategoryList1 = this.subCategoryList.filter(
          (item) => item.categoryId == this.selectedCategoryID
        ))
        : (this.subCategoryList1 = []);
      // getStatus is already called inside getAllPricingConfig at line 480, no need to call it again
      this.disablePost = false;

      if (this.selectedDept) {
        // this.getStatus(this.tempData);
        this.selectedDept.status = 'Processing';
      }
      if (this.modalInstance) {
        this.modalInstance.hide();
      }

      //this.getStatus(this.tempData);
    } catch (error) {
      console.error('Error in postPricingData:', error);
    }
  }

  setPriceConfigByQualityCondition(deptId: number) {
    for (var i = 0; i < this.getQuality.length; i++) {
      for (var j = 0; j < this.getCondition.length; j++) {
        let item: deptpriceconfig = new deptpriceconfig();
        item.qualityId = this.getQuality[i].qualityId;
        item.qualityColor = this.getQuality[i].qualityColor;
        item.qualityDescr = this.getQuality[i].qualityDescr;
        item.conditionId = this.getCondition[j].conditionId;
        item.conditionColor = this.getCondition[j].conditionColor;
        item.conditionDescr = this.getCondition[j].conditionDescr;
        item.departmentId = deptId;
        this.conditionQualities.push(item);
      }
    }
  }

  getAllConditions() {
    let userdata = this.masterService.getUserDetailsFromStorage();
    let com_id = userdata.companyID;
    this.masterService.getAllConditions(com_id).subscribe((res) => {
      this.getCondition = res as Conditions[];
    });
  }

  getQualities() {
    let userdata: any = this.masterService.getUserDetailsFromStorage();
    let id = userdata.companyID;
    this.masterService.getGrades(id).subscribe((res) => {
      if (res) {
        this.getQuality = res as grades[];
      }
      this.getQuality.map((item) => {
        let clr = item.qualityColor;
        clr = clr.replace(/ /g, '');
        clr = clr.toLowerCase();
        item.qualityColor = clr;
      });
    });
  }

  getAllStoreGroup(): Promise<void> {
    return new Promise((resolve, reject) => {
      let userdata = this.masterService.getUserDetailsFromStorage();
      this.masterService.getStoreGroupsCompany(userdata.companyID).subscribe({
        next: (res) => {
          this.storeGroups = (res as StoreGroupModel[]).filter(
            (item) => item.status === Status.Active
          );
          this.storegrp =
            this.storeGroups[this.masterService.selectedStoreGrpIndex];

          if (this.storeGroups.length > 0)
            this.selectedStoregrp = this.storeGroups[0].id;
          resolve();
        },
        error: (error) => {
          console.error('Error fetching store groups:', error);
          reject(error);
        },
      });
    });
  }

  showSelect(type: number) {
    if (type == 0) {
      this.showCustomSelect = !this.showCustomSelect;
    }
    if (type == 1) {
      this.showCustomSelect1 = !this.showCustomSelect1;
    }
  }

  async getSelect(ctg: any, ctgId: number, type: number) {
    if (type == 0) {
      this.showCustomSelect = !this.showCustomSelect;
      this.selectedVal = ctg;
      this.selectedVal1 = 'Choose Sub-Category';
      this.selectedCategoryID = ctgId;
      this.selectedSubCategoryID = 0;
      this.showCustomSelect1 = true;
    }
    if (type == 1) {
      this.showCustomSelect1 = !this.showCustomSelect1;
      this.selectedVal1 = ctg;
      this.selectedSubCategoryID = ctgId;
    }

    (await this.selectedCategoryID) > 0
      ? (this.subCategoryList1 = this.subCategoryList.filter(
        (item) => item.categoryId == this.selectedCategoryID
      ))
      : (this.subCategoryList1 = []);

    this.priceConfigPostDataString = [];
    this.getPriceForCategory();
  }

  async getPriceForDepartment() {
    this.departmentPrices = [];
    let data: any = this.updateceategoryPriceData;
    // Handle both camelCase and PascalCase
    let companyID = data.companyId || data.companyID;
    let priceTypeID = parseInt(data.pricingTypeId || data.pricingTypeID);
    let storeGroupId = data.storeGroupId || data.storeGroupId;
    let departmentId = data.departmentId || data.departmentId;

    await this.masterService
      .getpricefordepartment(companyID, priceTypeID, storeGroupId, departmentId)
      .subscribe((res) => {
        if (res) {
          let data1 = res as [];

          this.departmentPrices = JSON.parse(JSON.stringify(data1));
          var filterArray2 = data1.reduce((accumulator: any, current: any) => {
            if (
              !accumulator.some(
                (item: any) =>
                  item.price === current.price &&
                  item.qualityId == current.qualityId &&
                  item.conditionId == current.conditionId
              )
            ) {
              accumulator.push(current);
            }
            return accumulator;
          }, []);
          if (filterArray2.length > 0) {
            this.pricingDataList = [];
            this.pricingDataList = filterArray2;
          }
          if (data1.length != 0) {
            if (this.pricingDataList[0].price > 0)
              if (
                this.pricingDataList[0].pricingTypeId != 2 &&
                this.pricingDataList[0].pricingTypeId != 3
              ) {
                this.isPricePresent = true;
                this.buttonDisabled = true;
              }
          } else {
            this.pricingDataList.map((res) => {
              res.price = null;
              res.priceId = 0;
              this.buttonDisabled = false;
              this.isPricePresent = false;
            });
          }
        }
      });
  }

  async getPriceForCategory() {
    let data: any = this.updateceategoryPriceData;
    // Handle both camelCase and PascalCase
    let companyID = data.companyId || data.companyID;
    let priceTypeID = parseInt(data.pricingTypeId || data.pricingTypeID);
    let storeGroupId = data.storeGroupId || data.storeGroupId;
    let departmentId = data.departmentId || data.departmentId;
    let categoryId = parseInt(this.selectedCategoryID);
    let subCategoryID = parseInt(this.selectedSubCategoryID);

    await this.masterService
      .getPriceForCategory(
        companyID,
        priceTypeID,
        storeGroupId,
        departmentId,
        categoryId,
        subCategoryID
      )
      .subscribe((res) => {
        if (res) {
          let data1 = res as [];
          if (data1.length != 0) {
            this.pricingDataList = [];
            this.pricingDataList = data1;
            if (this.pricingDataList[0].price > 0)
              if (
                this.pricingDataList[0].pricingTypeId != 2 &&
                this.pricingDataList[0].pricingTypeId != 3
              ) {
                this.isPricePresent = true;
                this.buttonDisabled = true;
              }
          } else {
            this.pricingDataList.map((res) => {
              res.price = null;
              res.priceId = 0;
              this.buttonDisabled = false;
              this.isPricePresent = false;
            });
          }
        }
      });
  }

  getAllDepartments() {
    this.masterService.getMainDepartments().subscribe((res: any) => {
      this.departmentslist = res as Departments[];
    });
  }

  getSelectedDepartment(deptId: number) {
    const department = this.departmentslist.find(
      (dept) => dept.departmentId === deptId
    );
    if (department) {
      department.active = !department.active;
    }
  }

  getPricingType() {
    this.masterService.getDeptPricingConfig().subscribe((res) => {
      this.pricingType = res as pricetypeconfig[];
    });
  }

  async getDataForPriceConfig() {
    const storedData = await localStorage.getItem('pricing');
    if (storedData) {
      this.receivedData = JSON.parse(storedData);

      // Initialize percentage and status for each item if not present
      if (this.receivedData && Array.isArray(this.receivedData)) {
        this.receivedData.forEach((item: any) => {
          if (item.percentage === undefined) {
            item.percentage = 0;
          }
          if (item.status === undefined) {
            item.status = 'Not Added';
          }
          // Initialize pricingTypeID to 0 if not set (to show placeholder)
          if (item.pricingTypeID === undefined || item.pricingTypeID === null) {
            item.pricingTypeID = 0;
          }
        });
      }
    } else {
    }
  }

  triggerPriceBtn() {
    if (this.checkBtn) {
      this.checkBtn.nativeElement.click();
    }
  }

  getFormattedName(subCategoryId: number) {
    let subcategory: any = this.subCategoryList.find(
      (item) => item.subCategoryId === subCategoryId
    );

    if (
      !subcategory ||
      subcategory.parentSubcategoryId === 0 ||
      subcategory.parentSubcategoryId === null
    ) {
      return subcategory?.subCategoryName || '';
    }

    let fullPath: string =
      this.getFormattedName(subcategory.parentSubcategoryId) +
      ' - ' +
      subcategory.subCategoryName;
    return fullPath;
  }
  async handlePricingConfigClick(data: any) {
    await this.getAllPricingConfig(data);

    if (this.categoryList.length === 0) {
      this.toaster.error('No Category Found for this Department');
    } else {
      const modalElement = this.setPriceConfigModal.nativeElement;
      this.modalInstance = new (window as any).bootstrap.Modal(modalElement);
      this.modalInstance.show();
    }
  }

  async getAllPricingConfig(configData: any) {

    try {

      this.data = configData;

      // Handle both camelCase and PascalCase for backward compatibility
      this.pricingTypeID = parseInt(
        configData.pricingTypeId || configData.pricingTypeID || 0
      );
      this.storeGroupName = configData.storeGroupName;
      this.prcingTypeConfigData = configData;

      let pricingData: any = this.pricingType.find(
        (obj) => obj.pricingTypeId === this.pricingTypeID
      );

      if (!pricingData) {
        this.toaster.error('Invalid pricing type');
        return;
      }

      this.pricingTypeName = pricingData.pricingDescr;
      let userdata = this.masterService.getUserDetailsFromStorage();
      let companyID = userdata.companyID;

      // Use camelCase properties from configData
      const departmentId = configData.departmentId || configData.departmentId;
      const storeGroupId = configData.storeGroupId || configData.storeGroupId;
      const pricingTypeId =
        configData.pricingTypeId || configData.pricingTypeID;

      const res = await this.masterService
        .getPriceConfigTemplate(
          companyID,
          parseInt(pricingTypeId),
          departmentId,
          storeGroupId
        )
        .toPromise();

      this.pricingData = res as any;
      let departmentDATA: any = this.pricingData.departmentData[0];
      this.departmentsDetails = departmentDATA;
      this.departmentName = departmentDATA.departmentDescr;
      let categoryData: Array<any> = this.pricingData.categoryData;
      this.categoryList = categoryData;
      let subCategoryData: Array<any> = this.pricingData.subCategoryData;
      this.subCategoryList = subCategoryData;

      this.subCategoryList.forEach((item) => {
        item.displayName = this.getFormattedName(item.subCategoryId);
      });
      // this.subCategoryList = this.subCategoryList.filter(item =>
      //   !this.subCategoryList.some(sub => sub.parentSubcategoryId == item.subCategoryId)
      // );
      this.subCategoryList1 = this.subCategoryList;

      this.categoryList.map((res) => {
        if (res.pricePresent == 'true') {
          res.image = '../../../assets/Pricingscreen/statusIcon.svg';
        } else if (res.pricePresent == 'false') {
          res.image = '../../../assets/Pricingscreen/incomple-status.svg';
        }
      });
      this.subCategoryList1.map((res) => {
        if (res.pricePresent == 'true') {
          res.image = '../../../assets/Pricingscreen/statusIcon.svg';
        } else if (res.pricePresent == 'false') {
          res.image = '../../../assets/Pricingscreen/incomple-status.svg';
        }
      });
      (await this.selectedCategoryID) > 0
        ? (this.subCategoryList1 = this.subCategoryList.filter(
          (item) => item.categoryId == this.selectedCategoryID
        ))
        : (this.subCategoryList1 = []);
      let pricingDataList: Array<any> = this.pricingData.pricingData;
      this.pricingDataList = pricingDataList;
      this.obj = this.pricingDataList[0];

      this.updateceategoryPriceData = configData;

      if (
        this.pricingTypeID == 3 ||
        this.pricingTypeID == 6 ||
        this.pricingTypeID == 5
      ) {
        await this.getPriceForDepartment();
        // this.getPriceForCategory();
      }
      if (
        this.pricingTypeID == 1 ||
        this.pricingTypeID == 2 ||
        this.pricingTypeID == 4
      ) {
        await this.getPriceForCategory();
      }

      // Calculate status using the data already fetched instead of making another API call
      this.updateStatusFromCategoryData(configData, categoryData);
    } catch (error) {
      console.error('Error in getAllPricingConfig:', error);
    }
  }

  updateStatusFromCategoryData(configData: any, categoryData: Array<any>) {

    this.tempData = configData;

    const total = categoryData.length;
    const comp = categoryData.filter((res) => res.pricePresent === 'true');

    const percentage = total > 0 ? Math.floor((comp.length / total) * 100) : 0;
    const allTrue =
      total > 0 &&
      categoryData.every((category) => category.pricePresent === 'true');
    const allFalse = categoryData.every(
      (category) => category.pricePresent === 'false'
    );
    const status = allTrue
      ? 'Completed'
      : allFalse
        ? 'Not Added'
        : 'In Progress';

    // Update configData
    configData.percentage = percentage;
    configData.status = status;

    // CRITICAL: Also update the receivedData array item that's displayed in the template
    if (this.receivedData && Array.isArray(this.receivedData)) {
      const receivedItem = this.receivedData.find((item: any) => {
        const matchStoreGroup =
          item.storeGroupId == configData.storeGroupId ||
          item.storeGroupId == configData.storeGroupId;
        const matchDepartment =
          item.departmentId == configData.departmentId ||
          item.departmentId == configData.departmentId;
        return matchStoreGroup && matchDepartment;
      });

      if (receivedItem) {
        receivedItem.percentage = percentage;
        receivedItem.status = status;
      }
    }

    let receiveData = this.Deptpriceconfigarray.filter(
      (res) =>
        res.storeGroupId == configData.storeGroupId &&
        res.departmentId == configData.departmentId
    );
    if (
      receiveData.length > 0 &&
      receiveData[0].pricingTypeId != configData.pricingTypeId
    ) {
      this.dept.departmentDescr = configData.departmentDescr;
      let pricing = receiveData[0].pricingTypeId - 1;
      this.tempDescr = this.pricingType[pricing].pricingDescr;
    }
  }

 getStatus(configData: any) {
    this.tempData = configData;
    const userdata = this.masterService.getUserDetailsFromStorage();
    const companyID = userdata.companyID;

    // Handle both camelCase and PascalCase
    const pricingTypeId = configData.pricingTypeId || configData.pricingTypeID;
    const departmentId = configData.departmentId || configData.departmentId;
    const storeGroupId = configData.storeGroupId || configData.storeGroupId;

    this.masterService
      .getPriceConfigTemplate(
        companyID,
        pricingTypeId,
        departmentId,
        storeGroupId
      )
      .subscribe((res: any) => {
        this.pricingData = res;
        const categoryData: Array<any> = this.pricingData.categoryData;
        const departmentData: Array<any> = this.pricingData.departmentData;
        const subCategoryData: Array<any> = this.pricingData.subCategoryData;

        const total = categoryData.length;
        const comp = categoryData.filter((res) => res.pricePresent === 'true');

        const percentage =
          total > 0 ? Math.floor((comp.length / total) * 100) : 0;
        const allTrue =
          total > 0 &&
          categoryData.every((category) => category.pricePresent === 'true');
        const allFalse = categoryData.every(
          (category) => category.pricePresent === 'false'
        );
        const status = allTrue
          ? 'Completed'
          : allFalse
            ? 'Not Added'
            : 'In Progress';

        // Update configData
        configData.percentage = percentage;
        configData.status = status;

        // CRITICAL: Since configData is a reference from receivedData array,
        // the update above should automatically reflect in the UI
        // But let's ensure it's updated
      });

    let receiveData = this.Deptpriceconfigarray.filter(
      (res) =>
        res.storeGroupId == configData.storeGroupId &&
        res.departmentId == configData.departmentId
    );
    if (
      receiveData.length > 0 &&
      receiveData[0].pricingTypeId != parseInt(configData.pricingTypeID)
    ) {
      this.dept.departmentDescr = configData.departmentDescr;
      let pricing = receiveData[0].pricingTypeId - 1;
      this.tempDescr = this.pricingType[pricing].pricingDescr;
       this.existingPrices = this.getExistingPricesForDept(configData);
      this.triggerPriceBtn();
    }
  }
 getExistingPricesForDept(data: any): any[] {
  return this.Deptpriceconfigarray.filter(
    (p: any) =>
      p.storeGroupId === (data.storeGroupId ?? data.storeGroupID) &&
      p.departmentId === (data.departmentId ?? data.departmentID)
  );
}


  delLevel(i: number, price: deptpriceconfig) {
    this.pricingDataList.splice(i, 1);
    if (price.priceId) {
      this.delSinglePrice(price);
    }
  }
  addLevel() {
    this.disablePost = false;
    let userdata = this.masterService.getUserDetailsFromStorage();

    if (this.pricingDataList.length > 0) {
      let obj1 = {
        descr: parseInt(`Price ${this.postPricingData.length + 1}`),
        price: 0,
        companyID: userdata.companyID,
        pricingTypeId: this.pricingDataList[0].pricingTypeId,
      };
      this.pricingDataList.push(obj1);
    } else {
      this.pricingDataList.push(this.obj);
    }
  }

  delSinglePrice(data: deptpriceconfig) {
    if (
      this.pricingTypeID == 3 ||
      this.pricingTypeID == 5 ||
      this.pricingTypeID == 6
    ) {
      this.departmentPrices.forEach((item) => {
        if (item.price == data.price) {
          this.deletePrices.push(item.priceId.toString());
        }
      });
    } else {
      this.deletePrices.push(data.priceId.toString());
    }
    this.selectedIds = this.deletePrices.join(',');
  }

  deletePricingDept(data: any) {
    let user = this.masterService.getUserDetailsFromStorage();
    this.delpricingDept(
      data.departmentId,
      0,
      data.storeGroupId,
      user.companyID
    );
  }
  delDeptModal() {
    let data = this.tempData;
    let user = this.masterService.getUserDetailsFromStorage();

    this.delpricingDept(
      data.departmentId,
      0,
      data.storeGroupId,
      user.companyID
    );
  }

  delpricingDept(
    deptID: number,
    pricingID: number,
    storeGrpID: number,
    companyID: number
  ) {
    this.masterService
      .deletePricingDept(deptID, pricingID, storeGrpID, companyID)
      .subscribe((res) => {
        this.getAllPricingConfigs();
        this.tempData.percentage = 0;
        this.tempData.status = 'Not Added';
      });
  }

  clearData() {
    this.selectedIds = '';
    this.deletePrices = [];
    if (this.modalInstance) {
      this.modalInstance.hide();
    }
  }
}
